"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const ReactDOM = __importStar(require("react-dom"));
const create_open_promise_1 = require("./create-open-promise");
// We use `undefined` to signal that we don't have an observable value (yet). But for sync
// observables you want to be able to use `undefined` as a value. We use this boxed value
// to differentiate between "we don't have a value" and "we have a value and it's `undefined`"
const boxedUndefined = {};
function unboxUndefined(value) {
    return (value === boxedUndefined ? undefined : value);
}
function boxUndefined(value) {
    return (value === undefined ? boxedUndefined : value);
}
function isAsyncObservable(o) {
    const observable = o;
    return (!!observable &&
        !!observable.currentSync &&
        !!observable.current &&
        !!observable.emit);
}
function isSyncObservable(o) {
    const observable = o;
    return !!observable && !!observable.currentSync && !!observable.emit;
}
function isPromise(x) {
    const p = x;
    return p && !!p.catch && !!p.then;
}
function addListener(listeners, listener) {
    listeners.push(listener);
    return () => {
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            listeners.splice(index, 1);
        }
    };
}
function emit(event, previousEvent, listeners) {
    const promises = [];
    ReactDOM.unstable_batchedUpdates(() => {
        for (const listener of listeners.slice()) {
            try {
                const maybePromise = listener(event, previousEvent);
                if (isPromise(maybePromise)) {
                    promises.push(maybePromise);
                }
            }
            catch (e) {
                const type = event === undefined ? 'signal' : 'event';
                const eventString = event === undefined ? '' : ' event: ' + JSON.stringify(event);
                console.error('Error occurred in listener in ' + type + eventString);
                console.error(e);
            }
        }
    });
    return Promise.all(promises);
}
function observableFactory(getServerSideStorage) {
    function createObservable(initialValue, initialValueGetter, notifyFirstListener = false) {
        const listeners = [];
        const closing = (0, create_open_promise_1.createOpenPromise)();
        closing.then(() => (listeners.length = 0));
        let previousValue = undefined;
        let currentValue = initialValue;
        let resolveCurrentValue;
        const initialValuePromise = new Promise(resolve => {
            resolveCurrentValue = resolve;
        });
        let initialValueGetterCalled = false;
        let initialValueGetterResolved = false;
        if (initialValue !== undefined) {
            resolveCurrentValue(initialValue);
            initialValueGetterCalled = true;
            initialValueGetterResolved = true;
        }
        const emitValue = (event) => __awaiter(this, void 0, void 0, function* () {
            // It's very much intended to await the emit before setting the current value
            // since this lets an event listener delay an observable.
            const resolveInitialNeeded = currentValue === undefined;
            const newValue = boxUndefined(event);
            previousValue = currentValue;
            currentValue = newValue;
            const listenerResult = yield emit(event, previousValue, listeners);
            if (resolveInitialNeeded) {
                resolveCurrentValue(currentValue);
            }
            return listenerResult;
        });
        const callInitialValueGetter = () => __awaiter(this, void 0, void 0, function* () {
            if (initialValueGetter !== undefined &&
                initialValueGetterCalled === false) {
                initialValueGetterCalled = true;
                const localResolveCurrentValue = resolveCurrentValue;
                const value = yield initialValueGetter();
                // value === currentValue if the initial value getter internally runs
                // code to update its own value. In that case we've already emitted that
                // value so we don't want to do it again.
                if (value !== undefined && value !== currentValue) {
                    previousValue = currentValue;
                    currentValue = value;
                    emitValue(currentValue);
                    localResolveCurrentValue(currentValue);
                }
                else {
                    resolveCurrentValue = localResolveCurrentValue;
                }
                initialValueGetterResolved = true;
            }
        });
        return [
            {
                on(listener, notifyImmediate = false) {
                    if (notifyImmediate ||
                        (notifyFirstListener &&
                            !listeners.length &&
                            currentValue !== undefined)) {
                        listener(currentValue, previousValue);
                    }
                    return addListener(listeners, listener);
                },
                emit: emitValue,
                update(updater) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const current = currentValue === undefined
                            ? yield initialValuePromise
                            : unboxUndefined(currentValue);
                        const updated = updater(current);
                        yield emitValue(updated);
                    });
                },
                listeners() {
                    return listeners.length;
                },
                currentSync() {
                    return unboxUndefined(currentValue);
                },
                currentSyncOrThrowPromise(allowInitialUndefined) {
                    if (currentValue !== undefined) {
                        return unboxUndefined(currentValue);
                    }
                    // If we called `initialValueGetter` and `currentValue` is still undefined
                    // it means that we don't have a value yet
                    if (initialValueGetterResolved && allowInitialUndefined === true) {
                        return unboxUndefined(currentValue);
                    }
                    callInitialValueGetter();
                    throw initialValuePromise;
                },
                current() {
                    return __awaiter(this, void 0, void 0, function* () {
                        if (currentValue !== undefined) {
                            return Promise.resolve(unboxUndefined(currentValue));
                        }
                        else {
                            callInitialValueGetter();
                            return initialValuePromise;
                        }
                    });
                },
                whenClosed: closing,
            },
            (closingValue) => {
                if (closingValue === undefined) {
                    closingValue = unboxUndefined(currentValue);
                }
                closing.resolve(closingValue);
            },
        ];
    }
    return {
        /**
         * @name createSignal
         * @description
         * A signal is the simplest possible unit. It does not carry any data,
         * it's just an object that you can listen to. An example is when the
         * customer logs in or out.
         */
        createSignal() {
            if (!__BROWSER__) {
                return [
                    {
                        on() {
                            if (__DEV__) {
                                console.trace('Listening to events should not be done on the server as it can cause memory leaks');
                            }
                            return () => undefined;
                        },
                        emit() {
                            if (__DEV__) {
                                console.trace('Emitting values should not be done on the server since listening to value updates is not supported');
                            }
                            return Promise.resolve([]);
                        },
                        listeners() {
                            return 0;
                        },
                        get whenClosed() {
                            throw new Error('Not supported on the server');
                        },
                    },
                    () => { },
                ];
            }
            const listeners = [];
            const closing = (0, create_open_promise_1.createOpenPromise)();
            closing.then(() => (listeners.length = 0));
            return [
                {
                    on(listener) {
                        return addListener(listeners, listener);
                    },
                    emit() {
                        return emit(undefined, undefined, listeners);
                    },
                    listeners() {
                        return listeners.length;
                    },
                    whenClosed: closing,
                },
                () => closing.resolve(undefined),
            ];
        },
        /**
         * @name createEvent
         * @description
         * Events can do everything that a signal can, but it also has a specific
         * event value. The most notable event in Excite/Nitro is the history
         * event. It is triggered everytime that the History API is used to modify
         * the current history state, such as navigating back and/or forward as
         * well as when using UI state.
         */
        createEvent() {
            if (!__BROWSER__) {
                return [
                    {
                        on() {
                            if (__DEV__) {
                                console.trace('Listening to events should not be done on the server as it can cause memory leaks');
                            }
                            return () => undefined;
                        },
                        emit(event) {
                            if (__DEV__) {
                                console.trace('Emitting values should not be done on the server since listening to value updates is not supported');
                            }
                            return Promise.resolve([]);
                        },
                        listeners() {
                            return 0;
                        },
                        get whenClosed() {
                            throw new Error('Not supported on the server');
                        },
                    },
                    () => { },
                ];
            }
            const listeners = [];
            let previousValue = undefined;
            const closing = (0, create_open_promise_1.createOpenPromise)();
            closing.then(() => (listeners.length = 0));
            return [
                {
                    on(listener) {
                        return addListener(listeners, listener);
                    },
                    emit(event) {
                        const emitResult = emit(event, previousValue, listeners);
                        previousValue = event;
                        return emitResult;
                    },
                    listeners() {
                        return listeners.length;
                    },
                    whenClosed: closing,
                },
                (closingValue) => {
                    if (closingValue === undefined) {
                        closingValue = previousValue;
                    }
                    closing.resolve(closingValue);
                },
            ];
        },
        /**
         * @name createAsyncObservable
         * @description
         * The difference between a sync and an async observable is that a sync
         * observable is guaranteed to have a value that can be synchronously
         * retrieved. An async observable does not have that guarantee and is
         * useful for when you want to create an observable but you don't have
         * its initial value yet.
         */
        createAsyncObservable(initialValueGetterOrInitialValue, notifyFirstListener = true) {
            const initialValue = typeof initialValueGetterOrInitialValue === 'function'
                ? undefined
                : initialValueGetterOrInitialValue;
            if (!__BROWSER__) {
                const observableId = Math.random().toString();
                return [
                    {
                        on() {
                            if (__DEV__) {
                                console.trace('Listening to events should not be done on the server as it can cause memory leaks');
                            }
                            return () => undefined;
                        },
                        emit(value) {
                            var _a;
                            const serverSideStorage = (_a = getServerSideStorage === null || getServerSideStorage === void 0 ? void 0 : getServerSideStorage()) !== null && _a !== void 0 ? _a : {};
                            serverSideStorage[('observable-' + observableId)] = value;
                            return Promise.resolve([]);
                        },
                        listeners() {
                            return 0;
                        },
                        update(updater) {
                            var _a;
                            const serverSideStorage = (_a = getServerSideStorage === null || getServerSideStorage === void 0 ? void 0 : getServerSideStorage()) !== null && _a !== void 0 ? _a : {};
                            serverSideStorage['observable-' + observableId] = updater(serverSideStorage['observable-' + observableId]);
                            return Promise.resolve();
                        },
                        currentSyncOrThrowPromise(allowInitialUndefined) {
                            throw new Error('Not supported on the server');
                        },
                        current() {
                            throw new Error('Not supported on the server');
                        },
                        currentSync() {
                            var _a, _b;
                            const serverSideStorage = (_a = getServerSideStorage === null || getServerSideStorage === void 0 ? void 0 : getServerSideStorage()) !== null && _a !== void 0 ? _a : {};
                            return ((_b = serverSideStorage['observable-' + observableId]) !== null && _b !== void 0 ? _b : initialValue);
                        },
                        get whenClosed() {
                            throw new Error('Not supported on the server');
                        },
                    },
                    () => { },
                ];
            }
            const initialValueGetter = typeof initialValueGetterOrInitialValue === 'function'
                ? initialValueGetterOrInitialValue
                : () => Promise.resolve(initialValueGetterOrInitialValue);
            return createObservable(initialValue, initialValueGetter, notifyFirstListener);
        },
        /**
         * @name createSyncObservable
         * @description
         * Creates an observable whose value resolves synchronously.
         */
        createSyncObservable(initialValue) {
            if (!__BROWSER__) {
                const observableId = Math.random().toString();
                return [
                    {
                        on() {
                            if (__DEV__) {
                                console.trace('Listening to events should not be done on the server as it can cause memory leaks');
                            }
                            return () => undefined;
                        },
                        emit(value) {
                            var _a;
                            const serverSideStorage = (_a = getServerSideStorage === null || getServerSideStorage === void 0 ? void 0 : getServerSideStorage()) !== null && _a !== void 0 ? _a : {};
                            serverSideStorage['observable-' + observableId] = value;
                            return Promise.resolve([]);
                        },
                        listeners() {
                            return 0;
                        },
                        update(updater) {
                            var _a;
                            const serverSideStorage = (_a = getServerSideStorage === null || getServerSideStorage === void 0 ? void 0 : getServerSideStorage()) !== null && _a !== void 0 ? _a : {};
                            serverSideStorage['observable-' + observableId] = updater(serverSideStorage['observable-' + observableId]);
                            return Promise.resolve();
                        },
                        currentSyncOrThrowPromise(allowInitialUndefined) {
                            var _a, _b;
                            const serverSideStorage = (_a = getServerSideStorage === null || getServerSideStorage === void 0 ? void 0 : getServerSideStorage()) !== null && _a !== void 0 ? _a : {};
                            return ((_b = serverSideStorage['observable-' + observableId]) !== null && _b !== void 0 ? _b : initialValue);
                        },
                        currentSync() {
                            var _a, _b;
                            const serverSideStorage = (_a = getServerSideStorage === null || getServerSideStorage === void 0 ? void 0 : getServerSideStorage()) !== null && _a !== void 0 ? _a : {};
                            return ((_b = serverSideStorage['observable-' + observableId]) !== null && _b !== void 0 ? _b : initialValue);
                        },
                        get whenClosed() {
                            throw new Error('Not supported on the server');
                        },
                    },
                    () => { },
                ];
            }
            if (initialValue === undefined) {
                initialValue = boxedUndefined;
            }
            return createObservable(initialValue);
        },
        isAsyncObservable,
        isSyncObservable,
    };
}
exports.default = observableFactory;
